var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdsIconSaveFailure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "#E13146"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7454 6.06787C10.9732 5.82373 10.9732 5.42725 10.7454 5.18311C10.5175 4.93896 10.1475 4.93896 9.9196 5.18311L8.00006 7.2417L6.07871 5.18506C5.85085 4.94092 5.48079 4.94092 5.25293 5.18506C5.02507 5.4292 5.02507 5.82568 5.25293 6.06982L7.17428 8.12646L5.25475 10.1851C5.02689 10.4292 5.02689 10.8257 5.25475 11.0698C5.48262 11.314 5.85267 11.314 6.08053 11.0698L8.00006 9.01123L9.92142 11.0679C10.1493 11.312 10.5193 11.312 10.7472 11.0679C10.9751 10.8237 10.9751 10.4272 10.7472 10.1831L8.82585 8.12646L10.7454 6.06787Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdsIconSaveFailure);
export default __webpack_public_path__ + "static/media/SDS_icon_SaveFailure.72daf905d1f8ef8da97ac86ec26e2298.svg";
export { ForwardRef as ReactComponent };